
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 45c12.426 0 22.5-10.074 22.5-22.5C45.5 10.637 36.32.918 24.675.061 23.753-.006 23 .75 23 1.675c0 .925.752 1.667 1.674 1.747C34.467 4.27 42.15 12.488 42.15 22.5c0 10.576-8.574 19.15-19.15 19.15-10.576 0-19.15-8.574-19.15-19.15 0-4.608 1.627-8.836 4.339-12.14.613-.747.573-1.864-.16-2.493-.67-.573-1.674-.531-2.242.142A22.41 22.41 0 00.5 22.5C.5 34.926 10.574 45 23 45z"}}),_c('path',{attrs:{"d":"M24.511 12l-.222 16.356H21.71L21.49 12h3.022zM23 34.933a1.925 1.925 0 01-1.411-.589 1.925 1.925 0 01-.589-1.41c0-.549.196-1.02.589-1.412A1.925 1.925 0 0123 30.933c.548 0 1.018.197 1.411.59.393.392.589.862.589 1.41 0 .363-.093.697-.278 1a2.075 2.075 0 01-.722.734c-.296.177-.63.266-1 .266z"}})])
          )
        }
      }
    